// extracted by mini-css-extract-plugin
export default {"button":"ShadowButton_button__GWP5O"};